import {
  getValidFun
} from "valid_project"

const customValid = (func, msg = '请输入正确格式', reg = null, type = 'change') => {
  let customFunc = (rule, value, callback) => {
    if (!value || (value.length && value.length === 0)) {
      return callback()
    } else if (!func(value, reg)) {
      return callback(new Error(msg))
    } else {
      callback()
    }
  }
  return {
    trigger: type,
    validator: customFunc
  }
}

export function validMoney(msg = '请输入金额') { // 金额
  return customValid(getValidFun, msg, "money")
}
export function validEmail(msg = '请输入正确的邮箱') { // 邮箱
  return customValid(getValidFun, msg, "email")
}
export function validIdCard(msg = '请输入正确的身份证号码') { // 身份证
  return customValid(getValidFun, msg, "ID")
}
export function validMobile(msg = '请输入正确的手机号') { // 手机号
  return customValid(getValidFun, msg, "mobile")
}
export function validTel(msg = '请输入正确的固定电话') { // 固话
  return customValid(getValidFun, msg, "tel")
}
export function validNum(msg = '请输入正确的数字格式') { // 数字格式
  return customValid(getValidFun, msg, "number");
}
export function validInt(msg = '请输入整数') { // 整数格式
  return customValid(getValidFun, msg, "int");
}
export function validLetter(msg = '请输入英文字母') { // 英文格式
  return customValid(getValidFun, msg, "letter");
}

export function validateNozho(rule, value, callback) {
  if (value && value.length) {
    if (value[0].length && value[1].length) {
      let reg = /[\u4E00-\u9FA5]/i
      if (!reg.test(value[0])) {
        return callback()
      } else {
        return callback(new Error('邮箱不可包含中文'))
      }
    } else {
      return callback(new Error('请输入邮箱名或选择邮箱后缀'))
    }
  }
};



// WEBPACK FOOTER //
// ./src/common/valid.js